
import React, { useEffect, useState, useMemo } from "react";
import { Container, Accordion, Row, Col, Card } from "react-bootstrap";
import { FaChevronDown, FaChevronUp } from 'react-icons/fa'
import { useInternationalization } from "../hooks/useInternationalization";
import './component.css';
import { groupBy } from "../utils/objUtils"
import { useEncountersTracker } from "../hooks/useEncountersTracker";
import { FAQ_COSTANTS } from "../utils/jsCostants";

export const FaqBody = ({ faqState }) => {
    const { locale } = useInternationalization();

    const findUrgencyByUrgencyCode = code => {
        switch (parseInt(code)) {
            //rosso
            case 1:
                return 5
            //arancione
            case 2:
                return 4
            // blu / azzurro
            case 3:
                return 3
            //verde
            case 4:
                return 2
            //bianco
            case 5:
                return 1
            default:
                return 0
        }
    }

    const initialList = []

    const [openList, setOpenList] = useState(initialList);

    const [sezioneStato, setSezioneStato] = useState(initialList);
    const [sezioneAltreInfo, setSezioneAltreInfo] = useState(initialList);
    const [sezioneAtroByMacro, setSezioneAltroByMacro] = useState(initialList);

    // l'encounter va letto dallo stato
    const { trackedEncounters } = useEncountersTracker();
    /* fake data TODO: sostituire con dati veri */
    //const encounter = { codice: "1", stato: "6" }

    const faqKeys = () => {
        if (locale === "it") {
            return {
                descrSez: "descrizioneSezioneItaliano",
                testoDomanda: "testoDomandaItaliano",
                testoRisposta: "testoRispostaItaliano",
                descrMacro: "descrizioneMacroCategoriaItaliano"
            }
        } else {
            return {
                descrSez: "descrizioneSezioneInglese",
                testoDomanda: "testoDomandaInglese",
                testoRisposta: "testoRispostaInglese",
                descrMacro: "descrizioneMacroCategoriaInglese"
            }
        }
    }

    // lista degli elementi selezionati, serve a determinare quale chevron verrà visualizzata: l'indice presente corrisponde
    // all'accordion aperto, al toggle rimuove l'indice dalla lista e cambia chevron
    // TODO: sostituire con l'override della funzione useAccordionToggle (guarda CardStatusProntoSoccorso)
    const toggleOpen = index => {
        if (openList.includes(index)) {
            const newList = openList.filter(i => i !== index);
            setOpenList([...newList]);
        } else {
            setOpenList([...openList, index])
        }
    }

    useEffect(() => {
        if (faqState.faq && (faqState.faq.length > 0)) {
            var groupedBySezione = groupBy(faqState.faq, "codiceSezione");
            setSezioneStato(groupedBySezione[1]);
            setSezioneAltreInfo(groupedBySezione[2]);
            var groupedByMacro = groupBy(groupedBySezione[2], "codiceMacroCategoria");
            let app = [];
            for (const key in groupedByMacro) {
                app.push(groupedByMacro[key])
            }
            setSezioneAltroByMacro([...sezioneAtroByMacro, app]);
        }
    }, []);

    const allowedCodes = useMemo(
        () => trackedEncounters.map(enc =>
            findUrgencyByUrgencyCode(enc.code.code)),
        [trackedEncounters]
    );

    const allowedStatuses = useMemo(
        () => trackedEncounters.map(enc =>
            FAQ_COSTANTS[enc.generalStatus]),
        [trackedEncounters]
    );

    return (
        <Container
            className="shadow"
            style={{
                marginTop: "2rem",
                marginBottom: "2rem",
                width: "60em",
                maxWidth: "100%",
            }}>
            <Row>
                {(sezioneStato && (sezioneStato.length > 0)) && sezioneStato.map((el, index) =>
                    <React.Fragment key={index.toString()}>
                        {/* si effettua il parseInt del codice perché non è sicuro se sia una stringa on un intero
                            TODO: sostituire con dati veri */}
                        {(allowedCodes.includes(el.codiceDomanda) || allowedStatuses.includes(el.codiceDomanda)) &&
                            <Col md={6} lg={6} sm={12} xs={12} className="p-3" key={index.toString()} >

                                <Card
                                    className="text-dark border rounded shadow-sm p-2"
                                    style={{
                                        backgroundColor: "rgba(0,0,0,.0)",
                                    }}>

                                    <Accordion>
                                        {/* Rimosso <Accordion.Toggle> per non permettere all'accordion di chiudersi */}
                                        <Row className="align-items-center" style={{ marginLeft: 0, marginRight: 0 }} >
                                            <Col>
                                                <b>{el[faqKeys().testoDomanda]}</b>
                                            </Col>
                                        </Row>
                                        <Accordion.Collapse  >
                                            <Row className="align-items-center" style={{ marginLeft: 0, marginRight: 0 }} >
                                                <Col>
                                                    <Card.Text className="white-space-prewrap">
                                                        {el[faqKeys().testoRisposta]}
                                                    </Card.Text>
                                                </Col>
                                            </Row>
                                        </Accordion.Collapse>
                                    </Accordion>
                                </Card>
                            </Col>}
                        {/* si effettua il parseInt del codice perché non è sicuro se sia una stringa on un intero
                            TODO: sostituire con dati veri */}
                        {(parseInt(el.codiceDomanda) === sezioneStato[sezioneStato.length - 1].codiceDomanda) &&
                            <Col md={12} lg={12} sm={12} xs={12} className="p-3" key={index.toString()} >

                                <Card
                                    className="text-dark border rounded shadow-sm p-2"
                                    style={{
                                        backgroundColor: "rgba(0,0,0,.0)",
                                    }}>

                                    <Accordion>
                                        {/* Rimosso <Accordion.Toggle> per non permettere all'accordion di chiudersi */}
                                        <Row className="align-items-center" style={{ marginLeft: 0, marginRight: 0 }} >
                                            <Col>
                                                <b>{el[faqKeys().testoDomanda]}</b>
                                            </Col>
                                        </Row>
                                        <Accordion.Collapse  >
                                            <Row className="align-items-center" style={{ marginLeft: 0, marginRight: 0 }} >
                                                <Col>
                                                    <Card.Text className="white-space-prewrap">
                                                        {el[faqKeys().testoRisposta]}
                                                    </Card.Text>
                                                </Col>
                                            </Row>
                                        </Accordion.Collapse>
                                    </Accordion>

                                </Card>
                            </Col>}
                    </React.Fragment>
                )}

                {sezioneAltreInfo[0] &&
                    <Col md={6} lg={6} sm={12} xs={12} className="p-3" >
                        <Row>
                            <Col>
                                <b className="text-black-50" >{sezioneAltreInfo[0][faqKeys().descrSez]}</b>
                            </Col>
                        </Row>
                    </Col>}
                {(sezioneAtroByMacro && (sezioneAtroByMacro.length > 0)) && sezioneAtroByMacro[0].map((macro, index) =>

                    <Col md={12} lg={12} sm={12} xs={12} className="p-3" key={index.toString()} >

                        <Card
                            className="text-dark border rounded shadow-sm p-2"
                            style={{
                                backgroundColor: "rgba(0,0,0,.0)",
                            }}>
                            <Accordion>
                                <Accordion.Toggle onClick={() => toggleOpen(index)} className="border-0" eventKey={index} as={Card.Header} style={{ display: "inherit", backgroundColor: '#ffffff' }}>
                                    <Row className="align-items-center" style={{ marginLeft: 0, marginRight: 0 }} >
                                        <Col md={10} lg={10} sm={10} xs={10} >
                                            <b>{macro[0][faqKeys().descrMacro]}</b>
                                        </Col>
                                        <Col md={2} lg={2} sm={2} xs={2} className="text-center" >
                                            {((openList.length > 0) && openList.includes(index)) ? <FaChevronUp /> : <FaChevronDown />}
                                        </Col>
                                    </Row>
                                </Accordion.Toggle>
                                {macro.map((sezione, key) =>
                                    <Accordion.Collapse eventKey={index} key={key.toString()} >
                                        <Card.Body className={key === 0 ? "p-0 pt-3 mx-3 mb-3 mt-2 border-top" : null}>
                                            <Card.Text className="white-space-prewrap">
                                                <b className="text-black-50">{sezione[faqKeys().testoDomanda]}</b><br />
                                                <span dangerouslySetInnerHTML={{__html: sezione[faqKeys().testoRisposta]}} />
                                            </Card.Text>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                )}
                            </Accordion>
                        </Card>
                    </Col>
                )}
            </Row>
        </Container>
    )
}


